/**
 * 渠道企业类型（与后端 EhannelTypeEnum、portal_sys_enterprise.channel_type 一致）
 */
export const ChannelTypeEnum = {
  /** 专项治理工程渠道 */
  GOVERNANCE_CHANNEL: {
    value: '0',
    label: '专项治理工程渠道'
  },
  /** 版权产业渠道 */
  INDUSTRY_CHANNEL: {
    value: '1',
    label: '版权产业渠道'
  }
}

/**
 * 渠道身份类型（与后端 EhannelChannelIdentityTypeEnum 一致）
 */
export const ChannelIdentityTypeEnum = {
  PRIMARY: { code: 'PRIMARY', label: '一级渠道' },
  CITY_ASSOC: { code: 'CITY_ASSOC', label: '直属事业单位及市级文艺家协会' },
  DISTRICT_ASSOC: { code: 'DISTRICT_ASSOC', label: '区级文艺家协会' },
  ART_NEW_ORG: { code: 'ART_NEW_ORG', label: '文艺两新组织' },
  SUPPORT_REGION: { code: 'SUPPORT_REGION', label: '对口帮扶地区组织' },
  SCHOOL: { code: 'SCHOOL', label: '学校' },
  TRADE_ASSOC: { code: 'TRADE_ASSOC', label: '行业协会' },
  CREATIVE_PARK: { code: 'CREATIVE_PARK', label: '文化创意园区' },
  PROFESSIONAL_MARKET: { code: 'PROFESSIONAL_MARKET', label: '专业市场' },
  IP_SERVICE_PLATFORM: { code: 'IP_SERVICE_PLATFORM', label: '知识产权服务平台' }
}

/**
 * @param {string|number|null|undefined} code
 * @returns {boolean}
 */
export function isGovernanceChannel(code) {
  if (code === null || code === undefined || code === '') return false
  return String(code) === ChannelTypeEnum.GOVERNANCE_CHANNEL.value
}

/** 专项治理渠道身份：一级渠道 */
export const GOVERNANCE_CHANNEL_IDENTITY_PRIMARY = ChannelIdentityTypeEnum.PRIMARY.code

/** 专项治理渠道身份：区级文艺家协会 */
export const GOVERNANCE_CHANNEL_IDENTITY_DISTRICT_ASSOC = ChannelIdentityTypeEnum.DISTRICT_ASSOC.code


/**
 * 是否为专项治理一级渠道
 * @param {{ channelType?: string|number|null, channelIdentityType?: string, channelParentId?: number|string|null }} [mainBody]
 * @returns {boolean}
 */
export function isGovernancePrimaryChannel(mainBody) {
  if (!mainBody || !isGovernanceChannel(mainBody.channelType)) return false
  const idType = mainBody.channelIdentityType != null && mainBody.channelIdentityType !== ''
    ? String(mainBody.channelIdentityType).trim()
    : ''
    console.log(idType)
  if (idType === GOVERNANCE_CHANNEL_IDENTITY_PRIMARY) return true
  return false
}
